import userMessageType from "./userMessageType";

export const handleSetDetailForUpdate = (data) => ({
  type: userMessageType.SET_UPDATE_COUNT_UNREAD_MESSAGE,
  payload: data,
});
